import React from "react";

const variants = {
  primary: "bg-primary/10 text-primary",
  success: "bg-success-light text-success",
  warning: "bg-yellow-100 text-warning",
  danger:  "bg-red-100 text-danger",
  muted:   "bg-surface-border text-brand-muted",
};

const Badge = ({ children, variant = "muted", className = "" }) => (
  <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold ${variants[variant]} ${className}`}>
    {children}
  </span>
);

export default Badge;
